const choices = {
    yes: 'Oui',
    no: 'Non',
};

export default choices;
